/* eslint-disable no-console */
import { AppDetails } from "../../domain/entities";
import { version } from "../../../../../package.json";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const appDetailsKeys = {
  all: ["app-details"] as const,
};

const semverGreaterThan = (versionA: string, versionB: string): boolean => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);

  const compare = versionsA.map((number, index) => {
    const a = Number(number);
    const b = Number(versionsB.length > index ? versionsB[index] : "");

    if (a !== b) return a > b || isNaN(b);

    return false;
  });

  return !!compare.find((value) => value === true);
};

const useGetAppDetails = (): UseQueryResult<AppDetails> => {
  return useQuery(
    appDetailsKeys.all,
    async () =>
      await fetch("/app.json").then(
        (response) => response?.json() as unknown as AppDetails
      ),
    {
      // 2 hours of stale time
      staleTime: 120 * 60 * 1000,
      onSuccess: (data) => {
        if (semverGreaterThan(data.version, version)) {
          caches
            .keys()
            .then((names) => {
              names.forEach(async (name) => {
                await caches.delete(name);
              });
            })
            .finally(() => {
              window.location.reload();
            });
        }
      },
      onError: (error) => console.log(error),
    }
  );
};

export { useGetAppDetails };
